import { AxiosError } from "axios";
import { validateDataResponse } from "commons/helpers";

import { GetMigrationScriptParams, MigrationScriptFileDetail, MigrationScriptRequest, MigrationScriptResponse } from "./migrate.schema";
import { callAddMigrationScript, callRetrieveMigrationScript, callRetrieveMigrationScriptDetailContent } from "./migrate.datasorce";


export async function addMigrationScript(data: MigrationScriptRequest) {
    try {
        const response = await callAddMigrationScript(data);
        const result: string = validateDataResponse(response);

        return result;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function getMigrationScript(params: GetMigrationScriptParams) {
    try {
        const response = await callRetrieveMigrationScript(params);
        const result: MigrationScriptResponse[] = validateDataResponse(response);

        return result;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

export async function getMigrationScriptContent(filePath: string) {
    try {
        const response = await callRetrieveMigrationScriptDetailContent(filePath);
        const result: string = validateDataResponse(response);

        return result;
    } catch (error) {
        if (error instanceof AxiosError && error.response) {
            throw new Error(validateDataResponse(error.response).message);
        }

        throw error;
    }
}

